import React from 'react'
import { useTheme, useMediaQuery } from '@mui/material'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import PropTypes from 'prop-types'
import { StyledDialog } from './components'
import OpsotButton from '../OpsotButton/index'
import OpsotTypography from '../OpsotTypography/index'

const OpsotModal = ({
	title,
	body,
	isOpen,
	onDismiss,
	dismissText = 'Dismiss',
	allowClose = true
}) => {
	const theme = useTheme()
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))

	return (
		<StyledDialog
			componentsProps={{
				backdrop: {
					style: { backgroundColor: theme.palette.primary.main, opacity: 0.95 }
				}
			}}
			open={isOpen}
			onClose={allowClose ? onDismiss : () => {}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			fullWidth
			scroll="paper"
		>
			<DialogContent>
				<OpsotTypography
					id="modal-modal-title"
					variant={isSmallScreen ? 'responsiveH3' : 'desktopH3'}
					content={title}
				/>
				<OpsotTypography
					id="modal-modal-body"
					component="div"
					variant="bodySmall"
					content={body}
				/>
				{allowClose && (
					<DialogActions
						sx={{
							justifyContent: 'flex-start',
							padding: '0rem',
							marginTop: '2rem'
						}}
					>
						<OpsotButton
							sx={{ marginRight: 'auto', justifyContent: 'flex-start' }}
							autoFocus
							onClick={onDismiss}
							variant="text"
							text={dismissText}
							align="left"
						/>
					</DialogActions>
				)}
			</DialogContent>
		</StyledDialog>
	)
}

export default OpsotModal

OpsotModal.propTypes = {
	title: PropTypes.string.isRequired,
	body: PropTypes.node.isRequired,
	isOpen: PropTypes.bool.isRequired,
	onDismiss: PropTypes.func,
	dismissText: PropTypes.string,
	allowClose: PropTypes.bool
}
